export const assetEvidencePurposes = ['Asset register', 'PPM schedule', 'Operating and maintenance manual', 'Certificate', 'Warranty evidence', 'Photograph', 'Other asset evidence'];
//# sourceMappingURL=asset-evidence.js.map